<template>
    <div class="cerify-code-panel">
        <!-- 验证码输入区域 -->
        <div class="verify-code-area"
             :style="{'width': '146px'}">
            <div class="verify-input-area">
                <input type="text"
                       class="varify-input-code"
                       v-model="inputValue"
                       :placeholder="$t('验证码')"
                       v-on:blur="checkCode()" />
            </div>
        </div>
        <!-- code区域 -->
        <div class="verify-code"
             @click="setCode"
             :style="{
                    'width': width,
                    'height': height,
                    'line-height': height,
                    'font-size': fontSize,
                    'background-color': containerBackgroundColor,
                    'color': containerColor
                }">
            <!-- 显示字符串 -->
            <span :style="code.style"
                  v-for="(code,index) in codeShow"
                  :key="index">
                {{code.char || code}}
            </span>
        </div>
    </div>
</template>
<script type="text/babel">
/**
 * Code
 * @description 常规的图片文字识别或者数字计算
 * */
import { _codeChars, _codeColor1, _codeColor2 } from './util/utils'

export default {
    name: 'VerifyCode',
    props: {
        type: {
            type: String,
            default: '1'
        },
        // 位数，仅在type=2时生效
        figure: {
            type: Number,
            default: 100
        },
        // 算法，支持加减乘，0为随机，仅在type=2时生效
        arith: {
            type: Number,
            default: 0
        },
        width: {
            type: String,
            default: '200px'
        },
        height: {
            type: String,
            default: '60px'
        },
        fontSize: {
            type: String,
            default: '30px'
        },
        codeLength: {
            type: Number,
            default: 6
        }
    },
    data () {
        return {
            isEnd: false,
            // 输入的值
            inputValue: '',
            // 颜色
            containerBackgroundColor: '#fff',
            containerColor: '#fff',

            codeChose: '', // 应该输入的code
            codeShow: [] // 显示用的
        }
    },
    methods: {
        init () {
            this.setCode()
            this.$parent.$emit('ready', this)
        },

        /**
         * setCode
         * @description 设置验证码
         * */
        setCode () {
            if (this.isEnd === false) {
                this.containerBackgroundColor = _codeColor1[Math.floor(Math.random() * 3)]
                this.containerColor = _codeColor2[Math.floor(Math.random() * 5)]

                this.inputValue = ''

                this.codeShow = []
                this.codeChose = ''

                if (this.type === '1') { // 普通验证码 图片选择
                    for (var i = 0; i < this.codeLength; i++) {
                        var charNum = Math.floor(Math.random() * 52)
                        var tmpStyle = (charNum % 2 === 0) ? 'font-style:italic;margin-right: 10px' : 'font-weight:bolder'
                        tmpStyle += (Math.floor(Math.random() * 2) === 1) ? 'font-weight:bolder' : ''

                        this.codeChose += _codeChars[charNum]
                        this.codeShow.push({
                            style: tmpStyle,
                            char: _codeChars[charNum]
                        })
                    }
                } else if (this.type === '2') {
                    // 算法验证码
                    var num1 = Math.floor(Math.random() * this.figure)
                    var num2 = Math.floor(Math.random() * this.figure)

                    let codeShow = ''

                    if (this.arith === 0) {
                        var tmparith = Math.floor(Math.random() * 3)
                    }

                    switch (tmparith) {
                        case 1:
                            this.codeChose = parseInt(num1) + parseInt(num2)
                            codeShow = num1 + ' + ' + num2 + ' = ?'
                            break
                        case 2:
                            if (parseInt(num1) < parseInt(num2)) {
                                var tmpnum = num1
                                num1 = num2
                                num2 = tmpnum
                            }
                            this.codeChose = parseInt(num1) - parseInt(num2)
                            codeShow = num1 + ' - ' + num2 + ' = ?'
                            break
                        default:
                            this.codeChose = parseInt(num1) * parseInt(num2)
                            codeShow = num1 + ' × ' + num2 + ' = ?'
                            break
                    }

                    this.codeShow = codeShow.split('') // 转数组
                }
            }
        },
        /**
         * checkCode
         * @description 验证验证码
         * */
        checkCode () {
            let inputValue
            let codeChose
            if (this.type === '1') { // 普通验证码
                inputValue = this.inputValue.toUpperCase()
                codeChose = this.codeChose.toUpperCase()
            } else {
                inputValue = this.inputValue
                codeChose = this.codeChose
            }
            if (inputValue === codeChose) {
                this.isEnd = true
                this.$parent.$emit('success', this)
            } else {
                this.isEnd = false
                this.$parent.$emit('error', this)
                this.setCode()
            }
        },
        /**
         * refresh
         * @description 刷新
         * */
        refresh () {
            this.isEnd = false
            this.inputValue = ''
            this.setCode()
        }
    },
    watch: {
        // type变化则全面刷新
        type: {
            immediate: true,
            handler () {
                this.init()
            }
        }
    },
    mounted () {
        // 禁止拖拽
        this.$el.onselectstart = function () {
            return false
        }
    },
    i18n: {
        messages: {
            'en-US': {},
            'zh-CN': {}
        }
    }
}
</script>
<style lang="less" scoped>
/*常规验证码*/
.verify-code {
    float: left;
    font-size: 20px;
    text-align: center;
    cursor: pointer;
    margin-bottom: 5px;
    border: 1px solid #ddd;
    border-left: 0;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}

.cerify-code-panel {
    height: 100%;
    overflow: hidden;
}

.verify-code-area {
    float: left;
}

.verify-input-area {
    float: left;
    width: 100%;
    // padding-right: 10px;
}

.verify-change-area {
    line-height: 30px;
    float: left;
}

.varify-input-code {
    display: inline-block;
    width: 100%;
    height: 36px;
    line-height: 1.5;
    padding: 4px 7px;
    font-size: 12px;
    border: 1px solid #dcdee2;
    color: #515a6e;
    background-color: #fff;
    background-image: none;
    position: relative;
    cursor: text;
    -webkit-transition: border 0.2s ease-in-out, background 0.2s ease-in-out,
        -webkit-box-shadow 0.2s ease-in-out;
    transition: border 0.2s ease-in-out, background 0.2s ease-in-out,
        -webkit-box-shadow 0.2s ease-in-out;
    transition: border 0.2s ease-in-out, background 0.2s ease-in-out,
        box-shadow 0.2s ease-in-out;
    transition: border 0.2s ease-in-out, background 0.2s ease-in-out,
        box-shadow 0.2s ease-in-out, -webkit-box-shadow 0.2s ease-in-out;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
}
.varify-input-code:focus {
    outline: none;
    border-color: #2d8cf0;
    -webkit-box-shadow: 0 0 0 2px rgba(45, 140, 240, 0.2);
    box-shadow: 0 0 0 2px rgba(45, 140, 240, 0.2);
}
.varify-input-code::-webkit-input-placeholder {
    font-weight: 500;
    color: #ccc;
}
.varify-input-code:-ms-input-placeholder {
    font-weight: 500;
    color: #ccc;
}
.varify-input-code:-moz-placeholder {
    font-weight: 500;
    color: #ccc;
}
.varify-input-code::-moz-placeholder {
    font-weight: 500;
    color: #ccc;
}

.verify-change-code {
    color: #337ab7;
    cursor: pointer;
}
</style>
